﻿import angular from 'angular';
import './api/cart';

import './datastorage';

angular.module('folkeuni').factory('Cart', function (CartApi, DataStorage, $q, $cookies, $rootScope) {
  var cart = this;

  cart.add = function (cartObj) {
    var deferred = $q.defer();
    CartApi.add(cartObj).then(function (response) {
      deferred.resolve(response.data);
    }, function (errorResponse) {
      deferred.reject(errorResponse);
    });
    return deferred.promise;
  }

  cart.checkout = function (cartObj) {
    var deferred = $q.defer();

    CartApi.checkout(cartObj).then(function (cartObj) {
      deferred.resolve(cartObj.data);
    }, function (res) {
      deferred.reject(res);
    });
    return deferred.promise;
  }
  cart.customerInfoLocalStorageClear = function () {
    localStorage.removeItem("customerInfo");
  }

  cart.customerInfoLocalStorageGet = function () {
    var result = null;
    return new Promise((resolve, reject) => {
      DataStorage.get("customerInfo").then((data) => {
        result = data;
        resolve(result);
      }, function (message) {
        reject(message);
      });
    });
  }

  cart.customerInfoLocalStorageSet = function (customerObj) {
    DataStorage.set("customerInfo", JSON.stringify(customerObj));
  }

  cart.paymentMethods = [{
      value: 'Invoice',
      label: 'Faktura'
    },
    {
      value: 'Card',
      label: 'Med kort'
    }
  ];

  cart.paymentMethodGetByValue = function (id) {
    for (var i in cart.paymentMethods) {
      var currentPaymentMethod = cart.paymentMethods[i];
      if (currentPaymentMethod.value == id) {
        return currentPaymentMethod;
      }
    }

    return null;
  }

  cart.read = function () {
    var deferred = $q.defer();
    CartApi.read().then(function (response) {
      deferred.resolve(response.data);



      $rootScope.$broadcast('cart.update', response.data);
    }, function (res) {
      deferred.reject(res);
    });
    return deferred.promise;
  }
  
  cart.hasOrganizationTickets = function(cart){
    for(var i in cart.products){
      if(cart.products[i].organization){
        return true;
      }
    }
  }

  cart.hasStudentTickets = function (cart) {
    var hasStudendDiscount = false;

    for (var i in cart.products) {
      var currentProduct = cart.products[i];

      for (var y in currentProduct.discount) {
        var currentDiscount = currentProduct.discount[y];

        if (currentDiscount.type == "Student") {
          hasStudendDiscount = true;
          break;
        }
      }
      if (hasStudendDiscount) {
        break;
      }
    }
    return hasStudendDiscount;
  }

  cart.update = function (cardUpdateObj) {
    var deferred = $q.defer();
    CartApi.update(cardUpdateObj).then(function (response) {
      deferred.resolve(response.data);
      $rootScope.$broadcast('cart.update', response.data);
    }, function (errorResponse) {
      deferred.reject(errorResponse);
    });
    return deferred.promise;
  };

  cart.validate = function (cartObj) {
    var deferred = $q.defer();

    CartApi.validate(cartObj).then(function (cartObj) {
      deferred.resolve(cartObj.data);
    }, function (res) {
      deferred.reject(res);
    });

    return deferred.promise;
  }

  cart.voucherValidate = function (voucherObj) {
    var deferred = $q.defer();

    CartApi.voucherValidate(voucherObj).then(function (voucherObj) {
      deferred.resolve(voucherObj.data);
    }, function (res) {
      deferred.reject(res);
    });

    return deferred.promise;
  }

  cart.reset = function () {
    var deferred = $q.defer();

    CartApi.reset().then(function (res) {
      deferred.resolve(res);
    }, function (res) {
      deferred.reject(res);
    });
  }

  cart.waitlistSubscribe = function (waitlistObj) {
    var deferred = $q.defer();

    CartApi.waitlistSubscribe(waitlistObj).then(function (result) {
      deferred.resolve(result.data);
    }, function (res) {
      deferred.reject(res);
    });

    return deferred.promise;
  }

  return cart;
});